import axios from 'axios';

const baseLocalUrl = '/static/config.json';
const zhhUrl = 'http://192.168.110.248:10086/api/pay';

let configUrl = location.href.includes('192.168.110.248') ? zhhUrl : baseLocalUrl;

if (process.env.NODE_ENV !== 'development') {
  configUrl = baseLocalUrl;
}

const getApiConfigHook = () => {
  let apiConfig = void 0;

  return async () => {
    if (apiConfig) return apiConfig;

    try {
      const res = await axios.get(configUrl);

      apiConfig = res.data;
      return apiConfig;
    } catch (error) {
      console.log('无法从ZHH服务器获取配置，使用本地配置');
      const res = await axios.get(baseLocalUrl);

      apiConfig = res.data;
      return apiConfig;
    }
  };
};

const getApiConfig = getApiConfigHook();

export default getApiConfig;



// WEBPACK FOOTER //
// ./src/utils/configHook.js